import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { cn } from "@arcadeai/design-system/lib/utils";
import type { JSX } from "react";
import type { Jtbd } from "@/app/onboarding-first-win/api/get-jtbds";
import { OnboardingToolkitChips } from "@/app/onboarding-first-win/components/onboarding-toolkit-chips";

type JtbdCardProps = {
  disabled?: boolean;
  isCurrentGoal?: boolean;
  jtbd: Jtbd;
  onClick: () => void;
};

export function JtbdCard({
  disabled = false,
  isCurrentGoal = false,
  jtbd,
  onClick,
}: JtbdCardProps): JSX.Element {
  const services = jtbd.services;

  return (
    <button
      className={cn(
        "group w-full text-left focus-visible:outline-none",
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      )}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      <Card
        className={cn(
          "flex h-full min-h-52 flex-col transition-all duration-150 group-focus-visible:ring-2 group-focus-visible:ring-ring group-focus-visible:ring-offset-2 group-active:scale-[0.98]",
          isCurrentGoal
            ? "border-primary/50 bg-primary/10 ring-1 ring-primary/25"
            : !disabled && "hover:bg-accent hover:shadow-sm"
        )}
        size="sm"
      >
        <CardHeader className="flex-1">
          <CardTitle className="font-medium text-foreground text-sm leading-snug">
            {jtbd.name}
          </CardTitle>
          {jtbd.description && (
            <p className="mt-1 text-muted-foreground text-xs leading-relaxed">
              {jtbd.description}
            </p>
          )}
        </CardHeader>
        {services.length > 0 && (
          <CardContent>
            <OnboardingToolkitChips services={services} />
          </CardContent>
        )}
      </Card>
    </button>
  );
}
